import { FetcherError } from './StatusError';
import {
  FetchWrapperOptions,
  FetchWrapperFunction,
  PassThroughPayload,
  FetcherOptions,
  FetcherType,
  Fetcher
} from './fetcher.types';
import { processFetchContent } from './utils/processFetchContent';
import { buildFullUrl } from './utils/buildFullUrl';

function fetchWrapper(options: FetchWrapperOptions): FetchWrapperFunction {
  return async (urlOrPath, payload, fetchOptionsExtended) => {
    const { params, ...fetchOptions } = fetchOptionsExtended || {};
    const fullUrl = buildFullUrl({ urlOrPath, base: options.base, params });

    const stringifyPayload =
      typeof payload === 'number' || Array.isArray(payload) || payload?.constructor === Object;

    const reqInit: RequestInit = {
      method: options.method.toUpperCase(),
      body: stringifyPayload ? JSON.stringify(payload) : (payload as PassThroughPayload),
      ...fetchOptions,
      headers: {
        ...(stringifyPayload ? { 'content-type': 'application/json' } : undefined),
        ...fetchOptions?.headers
      },
      ...(fetchOptions.omitCookies && { credentials: 'omit' })
    };

    return fetch(fullUrl, reqInit).then(async (response) => {
      const data = await processFetchContent(response);

      if (!response.ok) {
        throw new FetcherError(fullUrl, response, data, options.method);
      }

      return {
        data,
        status: response.status,
        headers: Object.fromEntries(response.headers.entries())
      };
    });
  };
}

export const createFetcher = (fetcherOptions?: FetcherOptions) =>
  new Proxy(
    {
      base: '',
      ...fetcherOptions
    },
    {
      get: (obj: any, prop: string) => obj[prop] ?? fetchWrapper({ method: prop, ...obj })
    }
  ) as FetcherType;

export const fetcher = createFetcher() as Fetcher;
fetcher.create = createFetcher;
